import { configureStore, combineReducers } from '@reduxjs/toolkit';

import themeReducer from './features/theme/themeSlice';
import cartReducer from './features/cart/cartSlice';

const rootReducer = combineReducers({
    theme: themeReducer,
    cart: cartReducer,
});

export function makeStore() {
    return configureStore({
        reducer: rootReducer,
    });
}

export const store = makeStore();
